export default __webpack_public_path__ + "static/font-42feed500f37214caf8df43cf2501b22.svg";